<template>
<SmoothLoader class="post-preview">
    <span class="kicker block text-center mb-4 tracking-3 transition-colors text-white text-lg font-headline font-bold uppercase" v-html="post.kicker"></span>
    <Link :href="post.link" class="text-white transition-colors hover:text-secondary-500 focus:text-secondary-500 title transition-colors leading-tight block font-headline text-2xl vt:text-4xl uppercase text-center font-medium tracking-wider">
        {{ post.title }}
    </Link>
    <div v-if="post.excerpt.length" class="prose text-center transition-colors excerpt my-6 text-lg text-gray-400" v-html="post.excerpt"></div>
</SmoothLoader>
</template>

<script>
import { computed } from 'vue';
export default {
    props: {
        post: {
            required: true
        },
        size: {
            default: 'small'
        }
    },
    setup(props) {

    }
}
</script>